import React from 'react'
import styled from 'styled-components'
import icon from '../assets/search-icon.png'
const Icon = styled.img`
	width: 23px;
	position: relative;
	top: -3px;
	left: 10px;
`
const SearchIcon = () => <Icon src={icon} alt="search" />
const Button = styled.button`
  font-size: 1.2rem;
`
const Search = () =>
  <div className="p-4 offset-md-4 col-md-4 text-center">
    <Button className="w-75 btn btn-dark rounded-0">Search <SearchIcon /></Button>
  </div>

export default Search



// WEBPACK FOOTER //
// ./src/components/search-button.js